import Registration from '@/helpers/Registration';
import Requests from '@/helpers/Request';
import TV from '@/helpers/TV';
import Device from '@/helpers/Device';
import router from '@/router';
import Vue from 'vue';

export default {
  namespaced: true,
  state: () => ({
    deviceId: null,
    buildingId: null,
    groupId: null,
    type: this.getDeviceType,
    agent: this.getUserAgent,
    updated: Math.floor(new Date().getTime() / 1000),
    model: this.getDeviceModel,
    version: this.getDeviceVersion,
    software: this.getSoftware,
    mac: this.getMAC,
    ip: this.getIP,
    serialNumber: this.getSerial,
    platform: this.getPlatform,
    resHeight: this.getResolutionHeight,
    resWidth: this.getResolutionWidth,
    isDeviceLoaded: false,
    roomApps: {
      "ident" : [],
    },
  }),
  mutations: {
    setValues(state, context) {
      for (const item in context) {
        Vue.set(state, item, context[item]);
        // state[item] = context[item];
      }
    },
    setDeviceLoaded(state, value = true) {
      state.isDeviceLoaded = value;
    },
  },
  actions: {
    async init({ commit, dispatch, state }) {
      if (state.isDeviceLoaded) return Promise.resolve('Already loaded');
      const savedData = Registration.getData;
      if (savedData.deviceId) {
        try {
          const resHeight = Device.resolutionHeight;
          const resWidth = Device.resolutionWidth;
          const [serialNumber, mac, ip, response, currentFingerprint] = await Promise.all([
            Device.serialNumber,
            Device.mac,
            Device.ip,
            Requests.fetchDeviceInfo({
              deviceId: savedData.deviceId,
              bid: savedData.bid,
            }),
            Registration.getFingerprint(),
          ]);

          // Fingerprint-Abgleich: nur wenn API-Geraet bereits einen Fingerprint hat
          if (response.fingerprint) {
            if (response.fingerprint === currentFingerprint) {
              console.log('[Device] Fingerprint OK:', currentFingerprint);
            } else {
              console.warn('[Device] Fingerprint mismatch! API:', response.fingerprint, 'TV:', currentFingerprint);
            }
          } else if (currentFingerprint) {
            // Altgeraet ohne Fingerprint in der DB - jetzt nachtragen, wo alle
            // drei Geraetewerte lesbar waren. Erst damit ist es spaeter ueber
            // den Fingerprint wiederauffindbar, etwa nachdem sein Speicher
            // geleert wurde. Schlaegt das fehl, laeuft der Start normal weiter.
            console.log('[Device] Kein Fingerprint in API (altes Geraet) - wird nachgetragen');
            Requests.updateDeviceInfo({
              bid: savedData.bid,
              deviceId: savedData.deviceId,
              data: { fingerprint: currentFingerprint },
            }).catch((err) => console.log('[Device] Fingerprint nachtragen fehlgeschlagen:', err));
          } else {
            console.log('[Device] Kein Fingerprint in API und keiner berechenbar - weiter');
          }

          const mergedData = { ...savedData, ...response, resHeight, resWidth, serialNumber, mac, ip };
          console.log('RESPONSE DEVICE', response, savedData, mergedData);

          // Den Raum aus der DB auch DAUERHAFT uebernehmen, wenn er vom
          // gespeicherten abweicht.
          //
          // Bisher landete der Datensatz der API nur im Vuex-State - die lokale
          // Kopie im keymanager blieb auf dem Stand der Registrierung. Wird ein
          // Zimmer im Portal umbenannt, laufen beide auseinander, und auf einem
          // U800F stand im Speicher ein einzelnes "ä", waehrend die DB
          // "Z101" sagte. Solange die API erreichbar ist, faellt das nicht auf
          // (die Antwort ueberschreibt den Wert im State) - genau dann aber
          // nicht, wenn man sie braucht: nach einer Stoerung oder wenn sich das
          // Geraet aus dem Speicher wiederherstellt.
          if (response.room && response.room !== savedData.room) {
            console.log('[Device] Raum weicht ab - lokal nachziehen:', savedData.room, '->', response.room);
            // bid, deviceId und Seriennummer mitgeben: saveData schreibt nur,
            // was es bekommt, und wuerde die Seriennummer sonst neu vom Geraet
            // lesen. Absichtlich NICHT nachgezogen wird die Building-Id - ein
            // Gebaeudewechsel ist eine andere Baustelle als ein umbenanntes
            // Zimmer und soll nicht nebenbei passieren.
            Registration.saveData({
              bid: savedData.bid,
              deviceId: savedData.deviceId,
              room: response.room,
              serialNumber,
            });
          }

          await dispatch('saveDeviceData', mergedData);
          commit('setDeviceLoaded');
          return Promise.resolve();
        } catch (err) {
          console.log('eerr', err);
          // router.push({ name: 'Registration' });
          return Promise.reject();
        }
      } else {
        // Kein deviceId gespeichert → Fingerprint-Lookup versuchen
        try {
          const [fingerprint, serialNumber, mac] = await Promise.all([
            Registration.getFingerprint(),
            Device.serialNumber,
            Device.mac,
          ]);
          // Gesucht wird ueber den Fingerprint und, wenn der nichts findet oder
          // gar nicht berechenbar war, ueber die Seriennummer. Frueher wurde
          // ohne Fingerprint abgebrochen - das Geraet ging dann in die
          // Registrierung, obwohl sein Datensatz in der DB steht.
          const existingDevice = await Registration.findRegisteredDevice({ fingerprint, serialNumber, mac });
          if (existingDevice && existingDevice.id) {
            console.log('[Device] Geraet in der DB wiedergefunden:', existingDevice.id);
            await Registration.saveData({
              deviceId: existingDevice.id,
              bid: existingDevice.buildingId,
              room: existingDevice.room,
              serialNumber: existingDevice.serialNumber,
            });
            const mergedData = {
              ...existingDevice,
              resHeight: Device.resolutionHeight,
              resWidth: Device.resolutionWidth,
            };
            await dispatch('saveDeviceData', mergedData);
            commit('setDeviceLoaded');
            return Promise.resolve();
          }
        } catch (err) {
          console.log('[Device] Fingerprint-Lookup fehlgeschlagen:', err);
        }
        return Promise.reject();
      }
    },
    update({ commit, dispatch }) {
      commit('setDeviceLoaded', false);
      dispatch('init');
    },
    async saveDeviceData({ commit, dispatch }, context) {
      commit('setValues', context);

      dispatch(
        'initGlobalValues',
        {
          buildingId: context.buildingId,
          deviceId: context.deviceId,
          groupId: context.groupId,
        },
        { root: true }
      );
      return Promise.resolve();
    },
    turnOff({ dispatch }) {
      if (router.currentRoute.name !== 'Home') {
        router.push('/');
      }
      // AUSSCHALTEN ZUERST.
      //
      // Vorher stand hier das Loeschen der Cast-Daten davor - mit synchronem
      // SoftAP-Neustart auf Samsung und vier hcap-Aufrufen a 5 s Timeout auf LG.
      // Die Firmware bekam ihr powerOff also erst nach bis zu 18 s. Jetzt geht
      // der TV sofort aus.
      Device.turnOff();
      // Danach das Billige und Unverzichtbare: Loeschen beim Neustart scharf
      // schalten, SoftAP zumachen, offene Arbeit vormerken. Innerhalb eines
      // harten Zeitbudgets; der Rest laeuft beim Aufwachen (cast/clearGate
      // laesst vorher keine OTT-App starten).
      dispatch('cast/prepareForStandby', null, { root: true }).catch(() => {});
      dispatch('socket/reportState', null, { root: true });
    },
    turnOn({ dispatch }) {
      Device.turnOn();
      // Hier ist Zeit fuer den vollen Lauf: Anmeldedaten loeschen und ein neues
      // SoftAP-Passwort vergeben. No-op, wenn kein Standby vorausging.
      dispatch('cast/clearGuestCredentials', null, { root: true }).catch(() => {});
      dispatch('socket/reportState', null, { root: true });
    },
    // Liefert das Ergebnis des Geraets ({ ok, via, detail }, auf Tizen) - der
    // Standby-Neustart muss wissen, ob er gelaufen ist.
    reboot() {
      return Promise.resolve(Device.reboot());
    },
  },
  getters: {
    getHasTVPackageAssigned(state) {
      const packages = state['tv-packages'];
      if (!packages) return false;
      if (packages.ident === '') return false;
      return true;
    },
    getTVPackageName(state, getters) {
      if (!getters.getHasTVPackageAssigned) return '';
      return state['tv-packages'].ident;
    },
    getRoomAppInDevice(state, getters) {
      if(typeof state.roomApps === 'undefined' || typeof state.roomApps.ident === 'undefined') {
        return [];
      }
      return state.roomApps.ident;
    },
    getDevice(state, getters) {
      return this.state;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/device.js